export default {
    namespaced: true,
    state: {
        user: JSON.parse(localStorage.getItem('adminUser')),
    },
    getters: {
        getUser(state) {
            return state.user;
        },
    },
    mutations: {
        loggedIn(state, user) {
            if (user.token) {
                localStorage.setItem('adminUser', JSON.stringify(user));
                state.user = user;
            }
        },
        loggedOut(state){
            localStorage.removeItem('adminUser');
            state.user = null;
        }

    },
    actions: {
        storeAdminUser({commit}, adminUser) {
            commit('loggedIn', adminUser);
        },
        logout({commit}){
            commit('loggedOut');
        }
    },
};
